import api from './api';
import { handleError } from '../utils/errorHandler';
import {
  Indicador,
  GrupoFundo,
  GrupoFundoCreate,
  AtivoMaster,
  AtivoMasterCreate,
  DeParaAtivo,
  DeParaAtivoCreate,
  ContatoGrupoFundo,
  ContatoGrupoFundoCreate,
  CronogramaAmortizacao,
  CronogramaAmortizacaoCreate,
  CronogramaAmortizacaoUpdate,
} from '../types/ativoMaster';

export const searchAtivosMaster = async (search: string): Promise<AtivoMaster[]> => {
  try {
    const response = await api.get<{ results: AtivoMaster[] }>(
      `/ativos/ativo-master/?search=${encodeURIComponent(search)}`
    );
    return response.data.results ?? response.data as unknown as AtivoMaster[];
  } catch (error) {
    handleError(error, 'ao buscar ativos master');
    throw error;
  }
};

export const searchDeParaAtivos = async (search: string): Promise<DeParaAtivo[]> => {
  try {
    const response = await api.get<{ results: DeParaAtivo[] }>(
      `/ativos/de-para-ativo/?search=${encodeURIComponent(search)}`
    );
    return response.data.results ?? response.data as unknown as DeParaAtivo[];
  } catch (error) {
    handleError(error, 'ao buscar de-para de ativos');
    throw error;
  }
};

export const getAtivosMAster = async (): Promise<AtivoMaster[]> => {
  try {
    const response = await api.get<{ results: AtivoMaster[] }>('/ativos/ativo-master/?page_size=1000');
    return response.data.results ?? response.data as unknown as AtivoMaster[];
  } catch (error) {
    handleError(error, 'ao buscar ativos master');
    throw error;
  }
};

export const deleteAtivoMaster = async (id: number): Promise<void> => {
  try {
    await api.delete(`/ativos/ativo-master/${id}/`);
  } catch (error) {
    handleError(error, 'ao excluir ativo master');
    throw error;
  }
};

export const deleteGrupoFundo = async (id: number): Promise<void> => {
  try {
    await api.delete(`/ativos/grupo-fundo/${id}/`);
  } catch (error) {
    handleError(error, 'ao excluir grupo de fundo');
    throw error;
  }
};

export const deleteDeParaAtivo = async (id: number): Promise<void> => {
  try {
    await api.delete(`/ativos/de-para-ativo/${id}/`);
  } catch (error) {
    handleError(error, 'ao excluir mapeamento');
    throw error;
  }
};

export const getIndicadores = async (): Promise<Indicador[]> => {
  try {
    const response = await api.get<{ results: Indicador[] }>('/ativos/indicadores/');
    return response.data.results ?? response.data as unknown as Indicador[];
  } catch (error) {
    handleError(error, 'ao buscar indicadores');
    throw error;
  }
};

export const getGrupoFundoById = async (id: number): Promise<GrupoFundo> => {
  try {
    const response = await api.get<GrupoFundo>(`/ativos/grupo-fundo/${id}/`);
    return response.data;
  } catch (error) {
    handleError(error, 'ao buscar grupo de fundo');
    throw error;
  }
};

export const getGruposFundo = async (search?: string): Promise<GrupoFundo[]> => {
  try {
    const params = search ? `?search=${encodeURIComponent(search)}` : '';
    const response = await api.get<{ results: GrupoFundo[] }>(`/ativos/grupo-fundo/${params}`);
    return response.data.results ?? response.data as unknown as GrupoFundo[];
  } catch (error) {
    handleError(error, 'ao buscar grupos de fundo');
    throw error;
  }
};

export const createGrupoFundo = async (payload: GrupoFundoCreate): Promise<GrupoFundo> => {
  try {
    const response = await api.post<GrupoFundo>('/ativos/grupo-fundo/', payload);
    return response.data;
  } catch (error) {
    handleError(error, 'ao criar grupo de fundo');
    throw error;
  }
};

export const updateGrupoFundo = async (id: number, payload: Partial<GrupoFundoCreate>): Promise<GrupoFundo> => {
  try {
    const response = await api.patch<GrupoFundo>(`/ativos/grupo-fundo/${id}/`, payload);
    return response.data;
  } catch (error) {
    handleError(error, 'ao atualizar grupo de fundo');
    throw error;
  }
};

export const getAtivoMaster = async (id: number): Promise<AtivoMaster> => {
  try {
    const response = await api.get<AtivoMaster>(`/ativos/ativo-master/${id}/`);
    return response.data;
  } catch (error) {
    handleError(error, 'ao buscar ativo master');
    throw error;
  }
};

export const createAtivoMaster = async (payload: AtivoMasterCreate): Promise<AtivoMaster> => {
  try {
    const response = await api.post<AtivoMaster>('/ativos/ativo-master/', payload);
    return response.data;
  } catch (error) {
    handleError(error, 'ao criar ativo master');
    throw error;
  }
};

export const updateAtivoMaster = async (id: number, payload: Partial<AtivoMasterCreate>): Promise<AtivoMaster> => {
  try {
    const response = await api.patch<AtivoMaster>(`/ativos/ativo-master/${id}/`, payload);
    return response.data;
  } catch (error) {
    handleError(error, 'ao atualizar ativo master');
    throw error;
  }
};

export const createContatoGrupoFundo = async (payload: ContatoGrupoFundoCreate): Promise<ContatoGrupoFundo> => {
  try {
    const response = await api.post<ContatoGrupoFundo>('/ativos/contato-grupo-fundo/', payload);
    return response.data;
  } catch (error) {
    handleError(error, 'ao criar contato');
    throw error;
  }
};

export const updateContatoGrupoFundo = async (id: number, payload: Partial<ContatoGrupoFundoCreate>): Promise<ContatoGrupoFundo> => {
  try {
    const response = await api.patch<ContatoGrupoFundo>(`/ativos/contato-grupo-fundo/${id}/`, payload);
    return response.data;
  } catch (error) {
    handleError(error, 'ao atualizar contato');
    throw error;
  }
};

export const deleteContatoGrupoFundo = async (id: number): Promise<void> => {
  try {
    await api.delete(`/ativos/contato-grupo-fundo/${id}/`);
  } catch (error) {
    handleError(error, 'ao excluir contato');
    throw error;
  }
};

export const createDeParaAtivo = async (payload: DeParaAtivoCreate): Promise<DeParaAtivo> => {
  try {
    const response = await api.post<DeParaAtivo>('/ativos/de-para-ativo/', payload);
    return response.data;
  } catch (error) {
    handleError(error, 'ao criar de-para de ativo');
    throw error;
  }
};

export const getCronogramasByAtivoMaster = async (ativoMasterId: number): Promise<CronogramaAmortizacao[]> => {
  try {
    const response = await api.get<{ results: CronogramaAmortizacao[]; count: number }>(
      `/ativos/cronograma-amortizacao/?ativo_master=${ativoMasterId}`
    );
    return response.data.results ?? (response.data as unknown as CronogramaAmortizacao[]);
  } catch (error) {
    handleError(error, 'ao buscar cronogramas de amortização');
    throw error;
  }
};

export const createCronogramaAmortizacao = async (
  payload: CronogramaAmortizacaoCreate
): Promise<CronogramaAmortizacao> => {
  try {
    const response = await api.post<CronogramaAmortizacao>('/ativos/cronograma-amortizacao/', payload);
    return response.data;
  } catch (error) {
    handleError(error, 'ao criar cronograma de amortização');
    throw error;
  }
};

export const updateCronogramaAmortizacao = async (
  id: number,
  payload: CronogramaAmortizacaoUpdate
): Promise<CronogramaAmortizacao> => {
  try {
    const response = await api.patch<CronogramaAmortizacao>(`/ativos/cronograma-amortizacao/${id}/`, payload);
    return response.data;
  } catch (error) {
    handleError(error, 'ao atualizar cronograma de amortização');
    throw error;
  }
};

export const deleteCronogramaAmortizacao = async (id: number): Promise<void> => {
  try {
    await api.delete(`/ativos/cronograma-amortizacao/${id}/`);
  } catch (error) {
    handleError(error, 'ao excluir cronograma de amortização');
    throw error;
  }
};
